import Config from '../config-manager';
import { MTrackConsentData } from '../api-utils/endpoints/types';
import { APIError } from '../../system-libraries/api-types';
import { isNativeView } from '../../system-utils/common-utils';

export interface IMTrackConsentData {
  location: {
    pathname: string;
  };
  mTrackConsentData: IMTrackConsentState;
}

type HeaderVisibility = {
  showUtilityNav: boolean;
  showTabNav: boolean;
  showHeaderNav: boolean;
};

// defined in nba-product-application-webapp/src/store/mtrack-consent/types.ts
export interface IMTrackConsentState {
  error: APIError | null;
  data: MTrackConsentData & {};
  loading: boolean;
  ready: boolean;
}

export const determineShowMTrackHeader = ({ mTrackConsentData, location }: IMTrackConsentData): HeaderVisibility => {
  const { data, error } = mTrackConsentData;

  const whiteListConsent = data?.whiteListConsent ?? false;
  const clientConsent = data?.clientConsent ?? false;
  const locationPath = location?.pathname.toLowerCase();
  const isProductPage = locationPath === Config.get('paths.marketplace.product');
  const isApplicationPage = locationPath === Config.get('paths.product_application.root');
  const consent = whiteListConsent || clientConsent;
  const showTabNav = !isNativeView() && consent && !error;
  const showUtilityNav = !consent && !isNativeView() && (isProductPage || isApplicationPage);
  const showHeaderNav = !isNativeView();

  return { showUtilityNav, showTabNav, showHeaderNav };
};
